import { FieldNumber, FormRow, TextArea } from '@antoree/ant-ui';
import { Controller, FieldErrors } from 'react-hook-form';
import { defineMessage, useIntl } from 'react-intl';

export type FormRowTestResultProps = {
  control: any;
  isTextArea?: boolean;
  fieldName: string;
  isInvalid: boolean;
  error: string | undefined;
};

const FormRowTestResult: React.FC<FormRowTestResultProps> = ({
  control,
  isTextArea,
  fieldName,
  isInvalid,
  error,
}) => {
  const preventScroll1 = (event: any) => {
    event.target.blur();
  };
  const intl = useIntl();
  return (
    <FormRow fullWidth label="" isInvalid={isInvalid} error={error}>
      <Controller
        render={({ field: { ref, ...fieldRest } }) =>
          isTextArea ? (
            <TextArea
              style={{ border: '1px solid #CDCFD1' }}
              className="rounded-lg"
              compressed
              inputRef={ref}
              {...fieldRest}
              fullWidth
              isInvalid={isInvalid}
              placeholder={intl.formatMessage({
                defaultMessage: 'Detail',
              })}
            />
          ) : (
            <FieldNumber
              style={{ border: '1px solid #CDCFD1' }}
              className="rounded-lg"
              compressed
              inputRef={ref}
              {...fieldRest}
              fullWidth
              placeholder="0"
              isInvalid={isInvalid}
              onWheel={preventScroll1}
            />
          )
        }
        name={fieldName}
        control={control}
      />
    </FormRow>
  );
};

export default FormRowTestResult;
